import { get } from '../../utils/fetch'

export const getUser = async (username) => {
  const user = await get(`/users/${username}`)
  return user
}

export const getUserLatest = async (username, page = 1, per_page = 20) => {
  const latest = await get(`/users/${username}/latest?page=${page}&per_page=${per_page}`)
  return latest
}

export const getUserCardList = async () => {
  const result = await get('/users/mycard')
  return result
}

export const getUserLikes = async (username) => ({ username })
